import React from 'react';

interface FeedbackData {
  uuid: string;
  accountUuid: string;
  customerUuid: string;
  comment: string;
  feedbackType: string;
  createdAt: string;
  rating: number | null;
  updatedAt: string | null;
}

interface IProps {
  info: FeedbackData;
  feedbackInfo: any;
  setFeedbackInfo: any;
}

const FeedbackCard = (props: IProps) => {
  const { info, feedbackInfo, setFeedbackInfo } = props;

  function getFormattedTime(dateString: string): string {
    const date = new Date(dateString);
    const now = new Date();
    const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);

    const timeUnits: { unit: Intl.RelativeTimeFormatUnit; seconds: number }[] = [
      { unit: 'year', seconds: 60 * 60 * 24 * 365 },
      { unit: 'month', seconds: 60 * 60 * 24 * 30 },
      { unit: 'day', seconds: 60 * 60 * 24 },
      { unit: 'hour', seconds: 60 * 60 },
      { unit: 'minute', seconds: 60 },
      { unit: 'second', seconds: 1 }
    ];

    for (const { unit, seconds } of timeUnits) {
      const interval = Math.floor(diffInSeconds / seconds);
      if (interval >= 1) {
        return `${interval} ${unit}${interval > 1 ? 's' : ''} ago`;
      }
    }

    return 'just now';
  }

  return (
    <div
      key={info.uuid}
      className={`rounded-lg pt-3.5 pl-3.5 pr-2 pb-1.5 cursor-pointer hover:shadow-[0_0_10px_0px_#006BEA] transition-shadow duration-300 
        ${feedbackInfo.uuid === info.uuid ? 'border border-[#006BEA] bg-[#006BEA]' : 'bg-[#343434]'}`}
      onClick={() => setFeedbackInfo(info)}
    >
      <div className="flex gap-x-5">
        <label className="text-sm text-white font-bold cursor-pointer ">Message</label>
        <label className="text-sm text-white font-regular cursor-pointer max-w-40 md:max-w-60 lg:max-w-72 overflow-hidden text-ellipsis whitespace-nowrap">
          {info.comment}
        </label>
      </div>
      <div className="flex gap-x-9">
        <label className="text-sm text-white font-bold cursor-pointer ">Rating</label>
        <label className="text-sm text-white font-regular cursor-pointer max-w-40 md:max-w-60 lg:max-w-72 overflow-hidden text-ellipsis whitespace-nowrap">
          {info.rating}
        </label>
      </div>

      <div className="flex justify-end mt-1">
        <label className="text-xs font-bold text-[#D7D7D7] text-right cursor-pointer">
          {getFormattedTime(info.createdAt)}
        </label>
      </div>
    </div>
  );
};

export default FeedbackCard;
